import HSAPropertiesForm from './HSAPropertiesForm';

export default HSAPropertiesForm;
